<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div :class="`satisfaction-wrap ${normalOptionList.length <= 8 ? 'satisfaction-wrap-8' : ''}`" slot="body">
        <FormItem prop="value" :rules="rules">
          <div>
            <div class="inner-box">
              <!-- 非选项 -->
              <div v-if="config.answerConfig.satisfactionType !== 5" class="option-box">
                <div
                  v-for="item in normalOptionList"
                  :key="item.orderById"
                  :id="item.id"
                  :class="`item ${item.disabled ? 'item-disabled' : ''}`"
                  @click="selectOption(item, 1)"
                >
                  <div class="tips animated">{{ item.optionTitle }}<span class="arrow"></span></div>
                  <svg-icon :icon-class="`satisfaction-${item.icon}`" class="item-icon" />
                </div>
              </div>
              <!-- 选项 -->
              <div v-else class="option-box">
                <div
                  v-for="(item, index) in normalOptionList"
                  :key="item.orderById"
                  :id="item.id"
                  :class="`item option-item ${config.value > index ? 'item-active' : ''} ${item.disabled ? 'item-disabled' : ''}`"
                  @click="selectOption(item, 1)"
                >
                  <div class="tips animated">{{ item.optionTitle }}<span class="arrow"></span></div>
                  <span>{{ index+1 }}</span>
              </div>
              </div>
              <!-- 对应文案 -->
              <div v-if="normalOptionList.length" :class="`desc-box ${config.answerConfig.satisfactionType === 3 ? 'label-thumb' : ''} ${normalOptionList.length <= 3 ? 'label-short' : ''}`">
                <span class="label-left">{{ normalOptionList[0].optionTitle }}</span>
                <span class="label-right">{{ normalOptionList[normalOptionList.length - 1].optionTitle }}</span>
              </div>
            </div>
            <!-- 标签box -->
            <div v-if="config.value > 0 && config.answerConfig.satisfactionCommentLabel === '1'" class="tag-box">
              <span
                v-for="(item, index) in currTags"
                :key="index"
                :class="`tag ${item.selected ? 'active' : ''}`"
                @click="selTagOption(item)"
              >{{ cvtLang(item.id, item.tagValue) }}</span><span 
                v-if="config.answerConfig.satisfactionCommentInput === '1'"
                :class="`tag tag-input ${config.useTagInput ? 'active' : ''}`"
                @click="selTagInput()"
              >
                <svg-icon icon-class="edit-1" />{{ cvtLang('tipsEvaluate', config.tipsEvaluate) }}
              </span>
              <Input
                v-if="config.useTagInput"
                class="textarea wyb"
                v-model="config.otherTag"
                type="textarea"
                :row="4"
                :maxlength="100"
                show-word-limit
                :placeholder="cvtLang('tipsEvaluateInput', config.tipsEvaluateInput)"
                @input="otherTagChange"
              />
            </div>
            <!-- 不清楚/不知道 -->
            <div v-if="hasUnknownOption" :class="`unknown-box ${windowType === 'mobile' ? 'unknown-box-mobile' : ''}`">
              <el-radio v-model="unknownVal" :disabled="config.optionList[config.optionList.length - 1].disabled" @input="unknownChange" :label="1">
                <span :class="`txt ${config.optionList[config.optionList.length - 1].disabled === 1 ? 'txt-disabled' : ''}`">{{ config.optionList[config.optionList.length - 1].optionTitle }}</span>
              </el-radio>
            </div>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import answerValidate from './answerValidate'
import {addClass, removeClass} from '@/utils/dom'
export default {
  name: 'SatisfactionBoxAnswer',
  props: ['config'],
  data () {
    return {
      faceIcons: {
        2: ['face-sad', 'face-smile'],
        3: ['face-sad', 'face-normal', 'face-smile'],
        4: ['face-rage', 'face-sad', 'face-smile', 'face-laugh'],
        5: ['face-rage', 'face-sad', 'face-normal', 'face-smile', 'face-laugh'],
        6: ['face-rage', 'face-sad', 'face-normal', 'face-normal', 'face-smile', 'face-laugh'],
        7: ['face-rage', 'face-sad', 'face-sad', 'face-normal', 'face-smile', 'face-smile', 'face-laugh'],
        8: ['face-rage', 'face-sad', 'face-sad', 'face-normal', 'face-normal', 'face-smile', 'face-smile', 'face-laugh'],
        9: ['face-rage', 'face-sad', 'face-sad', 'face-normal', 'face-normal', 'face-normal', 'face-smile', 'face-smile', 'face-laugh'],
        10: ['face-rage', 'face-sad', 'face-sad', 'face-normal', 'face-normal', 'face-normal', 'face-normal', 'face-smile', 'face-smile', 'face-laugh']
      },
      loveIcons: {
        2: ['love-2-active', 'love-10-active'],
        3: ['love-2-active', 'love-6-active', 'love-10-active'],
        4: ['love-2-active', 'love-6-active', 'love-8-active', 'love-10-active'],
        5: ['love-2-active', 'love-4-active', 'love-6-active', 'love-8-active', 'love-10-active'],
        6: ['love-2-active', 'love-4-active', 'love-6-active', 'love-8-active', 'love-9-active', 'love-10-active'],
        7: ['love-2-active', 'love-4-active', 'love-6-active', 'love-7-active', 'love-8-active', 'love-9-active', 'love-10-active'],
        8: ['love-2-active', 'love-4-active', 'love-5-active', 'love-6-active', 'love-7-active', 'love-8-active', 'love-9-active', 'love-10-active'],
        9: ['love-2-active', 'love-3-active', 'love-4-active', 'love-5-active', 'love-6-active', 'love-7-active', 'love-8-active', 'love-9-active', 'love-10-active'],
        10: ['love-1-active', 'love-2-active', 'love-3-active', 'love-4-active', 'love-5-active', 'love-6-active', 'love-7-active', 'love-8-active', 'love-9-active', 'love-10-active']
      },
      currTags: [],
      unknownVal: 0,

      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {
    'config.value'(val) {
      if (!val) {
        // 清空选项需重置icon
        const {satisfactionType} = this.config.answerConfig
        this.config.optionList.forEach((item, index) => {
          item.icon = this.getIconStyle(satisfactionType, index)
        })
        this.unknownVal = 0
      }
    }
  },
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
    }),
    normalOptionList() {
      return this.config.optionList.filter(item => item.optionName !== '-999')
    },
    hasUnknownOption() {
      let flag = false
      if (this.config.optionList.find(item => item.optionName === '-999')) {
        flag = true
      }
      return flag
    }
  },
  methods: {
    selTagOption(item) {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      this.currTags.forEach(tagItem => {
        if (tagItem.keyId === item.keyId) {
          this.$set(tagItem, 'selected', tagItem.selected ? 0 : 1)
        }
      })
      this.config.selectedTags = this.currTags.filter(item => (item.selected === 1))
      this.config.otherAnswer.tags = this.config.selectedTags
    },
    selTagInput() {
      this.config.useTagInput = this.config.useTagInput ? 0 : 1
      this.config.otherAnswer.otherTag = this.config.otherTag
    },
    otherTagChange() {
      this.config.otherAnswer.otherTag = this.config.otherTag
    },
    getIconStyle(type, index) {
      const {satisfactionNumber} = this.config.answerConfig
      let iconStr = ''
      switch(type) {
      // 星型
      case 1:
        iconStr = 'star'
        break
      // 爱心
      case 2:
        iconStr = 'love'
        break
      // 点赞
      case 3:
        if (index === 0) {
          iconStr = 'thumb-1'
        } else {
          iconStr = 'thumb-2'
        }
        break
      // 笑脸
      case 4:
        iconStr = this.faceIcons[satisfactionNumber][index]
        break
      // 选项
      case 5:
        iconStr = ''
        break
      }
      if (type === 2) {
        return iconStr + (this.config.value > index ? '-2-active' : '' )
      } else {
        return iconStr + (this.config.value > index ? '-active' : '' )
      }
    },
    selectOption(item, show) {
      if (item.disabled) {return}
      const {satisfactionType, satisfactionNumber} = this.config.answerConfig
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      this.config.value = Number(item.optionName)
      this.unknownVal = 0

      // clear
      this.config.optionList.forEach(item => {
        if (item.icon.indexOf('-active') > -1) {
          item.icon = item.icon.replace('-active', '')
        }
      })
      
      if ([3, 4].includes(satisfactionType)) {
        // 点赞、笑脸
        item.icon = item.icon + '-active'
      } else if ([2].includes(satisfactionType)) {
        // 爱心
        this.config.optionList.forEach((item, index) => {
          if (this.config.value > index) {
            item.icon = this.loveIcons[satisfactionNumber][index]
          } else {
            item.icon = 'love'
          }
        })
      } else {
        this.config.optionList.forEach((item, index) => {
          if (this.config.value > index) {
            item.icon = item.icon + '-active'
          }
        })
      }
      if (show) {
        this.showTips(item)
      }
      this.setFormValue()
    },
    setFormValue() {
      this.currTags = this.config.optionList[Number(this.config.value) - 1].tags || []

      // rest
      this.restSelected()
    },
    restSelected() {
      this.currTags.forEach(tagItem => {
        this.$set(tagItem, 'selected', 0)
      })
      this.config.useTagInput = 0
      this.config.otherTag = ''
    },
    // 展示提示
    showTips(item) {
      const targetEl = document.getElementById(item.id)
      const targetW = window.getComputedStyle(targetEl).width
      const targetWNum = Number(targetW.replace('px', ''))
      const targetL = targetEl.getBoundingClientRect().x
      const tipsEl = targetEl.getElementsByClassName('tips')
      const arrowEl = targetEl.getElementsByClassName('arrow')
      const tipsW = window.getComputedStyle(tipsEl[0]).width
      const tipsWNum = Number(tipsW.replace('px', ''))
      const tipsLeft = -(tipsWNum - targetWNum) / 2
      const screenW = document.body.clientWidth
      arrowEl[0].setAttribute('style', `left:50%;`)

      // console.log('tipsWNum', tipsWNum)
      // console.log('targetWNum', targetWNum)
      // console.log('targetL', targetL)

      if (Math.abs(tipsLeft) > targetL) {
        // 左边超出
        arrowEl[0].setAttribute('style', `left: ${targetL + targetWNum / 2}px`)
        tipsEl[0].setAttribute('style', `left: ${-targetL}px; opacity: 1;`)
      } 
      else if ((targetL + tipsWNum / 2 + targetWNum / 2) > screenW) {
        // 右边超出
        arrowEl[0].setAttribute('style', `left: ${Math.abs(tipsLeft + -((targetL + tipsWNum / 2 + targetWNum / 2) - screenW) + -(targetWNum / 2))}px`)
        tipsEl[0].setAttribute('style', `left: ${tipsLeft + -((targetL + tipsWNum / 2 + targetWNum / 2) - screenW)}px; opacity: 1;`)
      }
      else {
        if (tipsWNum > targetWNum) {
          tipsEl[0].setAttribute('style', `left: ${tipsLeft}px; opacity: 1;`)
        } else {
          tipsEl[0].setAttribute('style', `opacity: 1;`)
        }
      }
      addClass(tipsEl[0], 'fadeInUp')

      tipsEl[0].addEventListener('animationend', function(e) {
        addClass(e.target, 'fadeOutDown')
        setTimeout(() => {
          removeClass(e.target, 'fadeInUp fadeOutDown')
          e.target.removeAttribute('style')
        }, 500)
      })
    },
    unknownChange() {
      const {satisfactionType} = this.config.answerConfig
      this.config.value = this.config.optionList[this.config.optionList.length - 1].optionName

      this.restSelected()
      // clear
      this.config.optionList.forEach(item => {
        if (item.icon.indexOf('-active') > -1) {
          item.icon = satisfactionType === 2 ? 'love' : item.icon.replace('-active', '')
        }
      })
    },

    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {
  },
  mounted () {
    const {satisfactionType} = this.config.answerConfig
    this.config.optionList.forEach((item, index) => {
      item.icon = this.getIconStyle(satisfactionType, index)
    })
    // 断点续答
    if (this.config.value) {
      this.config.optionList.forEach((item, index) => {
        if (this.config.value !== '-999' && this.config.value == item.optionName) {
          this.selectOption(item, 0)
        }
      })
      // 不清楚/不知道
      if (this.config.value === '-999') {
        this.unknownVal = 1
      }
    }

    const {otherAnswer, selectedTags} = this.config
    if (otherAnswer) {
      if (otherAnswer.otherTag) {
        this.config.useTagInput = 1
        this.config.otherTag = otherAnswer.otherTag
      }
      if (selectedTags && selectedTags.length) {
        selectedTags.forEach(item => {
          this.currTags.forEach(subItem => {
            if (subItem.keyId == item.keyId) {
              subItem.selected = 1
            }
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.satisfaction-wrap {
  .inner-box {
    min-width: 200px;
    display: inline-block;
    .option-box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .item-icon {
        font-size: 56px;
      }
      .item {
        margin-right: 12px;
        cursor: pointer;
        position: relative;
        .tips {
          position: absolute;
          top: -76px;
          left: 3px;
          min-width: 50px;
          width: max-content;
          background: #333;
          border-radius: 8px;
          color: #fff;
          font-size: 24px;
          padding: 0px 12px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          opacity: 0;
          .arrow {
            position: absolute;
            bottom: -16px;
            left: 50%;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-top-color: #333;
            transform: translate(-50%);
          }
        }
        &:last-child {
          margin-right: 0px;
        }
        &.item-disabled {
          .item-icon {
            opacity: .5;
          }
        }
      }
      .option-item {
        display: inline-block;
        text-align: center;
        background: linear-gradient(135deg, #EAEAEA 0%, #DDE1E3 100%);
        width: 56px;
        height: 56px;
        line-height: 56px;
        border-radius: 50%;
        color: #808695;
        font-size: 32px;
        font-weight: 500;
        margin-right: 12px;
        margin-bottom: 10px;
        &:last-child {
          margin-right: 0px;
        }
        &.item-active {
          background: #26BFAD;
          color: #fff;
        }
        &.item-disabled {
          opacity: .5;
        }
      }
    }
    .desc-box {
      display: flex;
      justify-content: space-between;
      color: #999;
      font-size: 24px;
      &.label-thumb {
        padding: 0 16px;
      }
      &.label-short {
        .label-left, .label-right {
          display: inline-block;
          max-width: 100px;
          word-break: break-all;
          line-height: 36px;
        }
        .label-left {
          text-align: left;
        }
        .label-right {
          text-align: right;
        }
      }
    }
    .add-box {
      margin-top: 20px;
    }
  }
  .tag-box {
    margin-top: 10px;
    .tag {
      display: inline-block;
      padding: 0px 14px;
      border: 2px solid #D5DBE6;
      border-radius: 4px;
      font-size: 24px;
      line-height: 48px;
      color: #2B313F;
      background: #FFFFFF;
      margin-right: 12px;
      margin-bottom: 6px;
      cursor: pointer;
      &.tag-input {
        .svg-icon {
          margin-right: 12px;
        }
      }
      &.active {
        border: 2px solid #26BFAD;
        color: #26BFAD;
        .svg-icon {
          color: #26BFAD;
        }
      }
    }
    .textarea {
      margin-top: 10px !important;
    }
  }
  .unknown-box {
    margin-top: 10px;
    >>> .el-radio {
      white-space: normal;
      line-height: 22px;
      word-break: break-word;
    }
    .txt {
      position: relative;
      left: -6px;
      top: 0px;
      font-weight: 400;
      color: #333;
      font-size: 28px;
      &.txt-disabled {
        color: #C0C4CC;
      }
    }
  }
  .unknown-box-mobile {
    >>> .el-radio {
      line-height: 48px;
      margin-right: 20px;
      display: flex;
      .el-radio__inner {
        width: 30px;
        height: 30px;
        position: relative;
        top: 8px;
        box-shadow:0 0 0 0 !important;
      }
      .el-radio__inner::after {
        width: 7px;
        height: 7px;
      }
      .el-radio__label {
        margin-left: 8px;
        line-height: 44px;
      }
    }
  }
  &.satisfaction-wrap-8 {
    .inner-box {
      .option-box {
        .item {
          margin-right: 20px;
          &:last-child {
            margin-right: 0px;
          }
        }
      }
    }
  }
}

.answer-pc {
  .satisfaction-wrap {
    width: 95%;
    .inner-box {
      min-width: 100px;
      .option-box {
        margin-top: 10px;
        .item-icon {
          font-size: 28px;
        }
        .item {
          margin-right: 12px;
          .tips {
            top: -38px;
            left: 2px;
            min-width: 25px;
            border-radius: 4px;
            font-size: 12px;
            line-height: 18px;
            padding: 0px 6px;
            height: 30px;
            line-height: 30px;
            .arrow {
              position: absolute;
              bottom: -9px;
              left: 50%;
              width: 0;
              height: 0;
              border: 5px solid transparent;
              border-top-color: #333;
              transform: translate(-50%);
            }
          }
          &:last-child {
            margin-right: 0px;
          }
        }
        .option-item {
          width: 28px;
          height: 28px;
          line-height: 28px;
          margin-right: 12px;
          margin-bottom: 5px;
          font-size: 16px;
          &:last-child {
            margin-right: 0px;
          }
        }
      }
      .desc-box {
        font-size: 12px;
        &.label-thumb {
          padding: 0 8px;
        }
        &.label-short {
          .label-left, .label-right {
            max-width: 50px;
            line-height: 18px;
          }
        }
      }
      .add-box {
        margin-top: 10px;
      }
    }
    .tag-box {
      margin-top: 5px;
      .tag {
        padding: 0px 7px;
        border: 1px solid #D5DBE6;
        border-radius: 2px;
        font-size: 12px;
        line-height: 24px;
        margin-right: 12px;
        margin-bottom: 6px;
        &.tag-input {
          .svg-icon {
            margin-right: 6px;
          }
        }
        &.active {
          border: 1px solid #26BFAD;
        }
      }
    }
    .unknown-box {
      .txt {
        left: -3px;
        top: 1px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/SatisfactionBox/SatisfactionBoxAnswer.vue